import React from "react";
import { useSpring, animated } from "react-spring";

const SidebarContent = (props) => {
  const props_ = useSpring({
    percComplete: !props.data.data
      ? 0
      : props.data.data.percentage_completeness_jan2020,
    percComplete21: !props.data.data
      ? 0
      : props.data.data.percentage_completeness_november2021,
    population: !props.data.data ? 0 : props.data.data._popsum,
    difference: !props.data.data
      ? 0
      : props.data.data.percentage_completeness_november2021 -
        props.data.data.percentage_completeness_jan2020,
  });

  return (
    <div className="sidebar-content">
      <div className="sidebar2021">
        <h1>
          {" "}
          {props.data.data._popsum === 26696210
            ? "Whole Madagascar"
            : props.data.data.label}{" "}
        </h1>
        <p>OSM buildings as of January 31, 2020 and November 24, 2021.</p>
        <p className="value-title"> OSM Completeness 2021 </p>
        <animated.div className="perc-comp">
          {props_.percComplete21.interpolate((x) => x.toFixed(2) + "%")}
        </animated.div>
        <p className="value-title"> Percentage Difference </p>
        <animated.div className="perc-comp">
          {props_.difference.interpolate((x) => x.toFixed(2) + "%")}
        </animated.div>
        <p className="sidebar-body">
          To estimate an area’s level of “OSM completeness”, we calculated the
          percentage of built-up lands that also have buildings on OSM.
        </p>
      </div>

      <div className="sidebar2020">
        <br></br>
        <div className="population-container">
          <p className="value-title"> Population 2021: </p>
          <animated.div className="population">
            {props_.population.interpolate((x) =>
              x.toLocaleString("en", { maximumFractionDigits: 0 })
            )}
          </animated.div>
        </div>
        <p className="value-title"> OSM Completeness 2020 </p>
        <animated.div className="perc-comp">
          {props_.percComplete.interpolate((x) => x.toFixed(2) + "%")}
        </animated.div>
        <p className="sidebar-body">
          To identify built up areas, we used the High Resolution Settlement
          Layer dataset from Connectivity Lab at Facebook that extracts building
          locations from satellite imagery.
        </p>
      </div>
    </div>
  );
};

export default SidebarContent;
